module.exports = __webpack_public_path__ + "media/images/twitter-icon-color-eb5cd53a42a15baeed8ccc4bd61b0a86.png";